import api from "@/services/axios_custom";
import API_ENDPOINTS from "@/util/api";
import { createAsyncThunk } from "@reduxjs/toolkit";

/**
 * Fetch all modules
 * GET /config/modules
 */
export const fetchModules = createAsyncThunk(
  "config/fetchModules",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(API_ENDPOINTS.config.configModule.getAllConfigModule);
      const sortedData = [...response.data].sort((a, b) =>
        a.moduleName.localeCompare(b.moduleName)
      );
      return sortedData;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

/**
 * Fetch all submodules
 * GET /config/submodules
 */
export const fetchAllSubmodules = createAsyncThunk(
  "config/fetchAllSubmodules",
  async (moduleId, { rejectWithValue }) => {
    try {
      const res = await api.get(
        `${API_ENDPOINTS.config.configModule.getAllConfigSubModules}`
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

/**
 * Fetch all submodules
 * GET /config/submodules
 */
export const fetchSubmodules = createAsyncThunk(
  "config/fetchSubmodules",
  async (moduleId, { rejectWithValue }) => {
    try {
      const res = await api.get(
        `${API_ENDPOINTS.config.configModule.getConfigSubModules}/${moduleId}`
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

/**
 * Fetch all reports
 * GET /config/reports
 */
export const fetchReports = createAsyncThunk(
  "config/fetchReports",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(API_ENDPOINTS.config.reports.getAll);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

/**
 * Fetch all table views
 * GET /config/table-views
 */
export const fetchTableViews = createAsyncThunk(
  "config/fetchTableViews",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(API_ENDPOINTS.config.tableViewsNew.getAll);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
